<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Modify Waitlist Entry</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="alert alert-danger text-center mb-3" role="alert"
         *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

    <p>
      Modifying <b>{{ waitlistEntry.first_name }} {{ waitlistEntry.last_name }}'s</b> pending waitlist entry.
    </p>

    <div class="form-group">
      <div class="form-check">
        <input class="form-check-input" type="radio"
               name="actionModifyBookingDeadline"
               id="actionModifyBookingDeadline"
               [(ngModel)]="selectedAction"
               [value]="ActionList.modifyBookingDeadline"
               [disabled]="loadingSubmit">
        <label class="form-check-label"
               for="actionModifyBookingDeadline">
          Modify Booking Deadline
        </label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="radio"
               name="actionExpireImmediately"
               id="actionExpireImmediately"
               [(ngModel)]="selectedAction"
               [value]="ActionList.expireImmediately"
               [disabled]="loadingSubmit">
        <label class="form-check-label"
               for="actionExpireImmediately">
          Expire Immediately
        </label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="radio"
               name="actionRevertToWaiting"
               id="actionRevertToWaiting"
               [(ngModel)]="selectedAction"
               [value]="ActionList.revertToWaiting"
               [disabled]="loadingSubmit">
        <label class="form-check-label"
               for="actionRevertToWaiting">
          Revert to "Waiting"
        </label>
      </div>
    </div>

    <div class="alert alert-info"
         *ngIf="selectedAction === ActionList.expireImmediately">
      This will set the waitlist entry's status to "Expired", allowing another entry to be invited to book.
    </div>
    <div class="alert alert-info"
         *ngIf="selectedAction === ActionList.revertToWaiting">
      This will set the waitlist entry's status back to "Waiting", allowing another entry to be invited to book.
    </div>

    <div class="form-group"
         *ngIf="selectedAction === ActionList.modifyBookingDeadline">
      <a href="#" class="float-right"
         (click)="$event.preventDefault(); newDeadlineDate = ''; newDeadlineTime = '';">
        Clear
      </a>
      <label class="form-text" for="newDeadlineDate">New Deadline</label>
      <app-deadline-date-time-input [idPrefix]="'newDeadline'"
                                    [timeZone]="waitlistEntry.time_zone"
                                    [(date)]="newDeadlineDate"
                                    [(time)]="newDeadlineTime"></app-deadline-date-time-input>
      <small class="form-text text-muted">
        Leave these blank in order to have no deadline, in which case the waitlist entry will remain pending until it is manually expired.
      </small>
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button class="btn btn-primary" type="button"
            [class.disabled]="selectedAction === null"
            [disabled]="selectedAction === null"
            *ngIf="!loadingSubmit"
            (click)="handleSubmit()">
      Save
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingSubmit">
      Loading...
    </button>
  </div>

</ng-container>
